
import projectListActions from './actions';

export default {
  ...projectListActions
};
